import type { QueryClient } from "@tanstack/react-query";
import i18next from "i18next";
import { ApiGetUserInfo } from "@/api";
import { clearToken, saveToken } from "@/lib/auth";
import { normalizeUserInfo } from "@/lib/normalizeUserInfo";
import { useUserStore } from "@/store/useUserStore";

/** 登录/注册成功后：写 token、拉取 userInfo（含 authType）、刷新 Query */
export async function finishAuthSession(params: {
  token: string;
  email?: string | null;
  queryClient: QueryClient;
}): Promise<void> {
  const { token, email, queryClient } = params;

  saveToken(token);
  if (email !== undefined) {
    useUserStore.setState({ email: email ?? null });
  }

  try {
    const userInfoResponse = await ApiGetUserInfo();
    if (!userInfoResponse.data?.uid) {
      throw new Error(i18next.t("toast.login.fetchUserInfoFailed"));
    }

    useUserStore.getState().setAuthSession({
      email: email ?? useUserStore.getState().email,
      userInfo: normalizeUserInfo(userInfoResponse.data),
    });

    await queryClient.invalidateQueries({ queryKey: ["getUserInfo"] });
    await queryClient.invalidateQueries();
  } catch (error) {
    clearToken();
    useUserStore.getState().clearUserInfo();
    throw error;
  }
}
